import { Box, Checkbox } from "@chakra-ui/react";
import { Card, ExpandableItem } from "@components/ui-kit";
import { t } from "@lingui/macro";
import { MediaRow } from "@src/utils/components/dropzone";
import { observer } from "mobx-react-lite";
import { Fragment } from "react";
import { InvoiceTypeEnum, useInvoiceStore } from "../../../store";

export const FilesCard = observer(function FilesCard() {
  const store = useInvoiceStore();
  const pdfFiles = store.pdfFiles;

  // When no brand_id is selected by user,
  // there is no project_id selected as well and
  // therefore there is no input to fetch new pdfFiles,
  // but some pdfFiles can be loaded from request before.
  if (
    (!pdfFiles.brand?.length && !pdfFiles.project?.length) ||
    store.form.brand_ids.value.length === 0
  ) {
    return null;
  }

  const onCheck = (id: string) => {
    const isChecked = store.form.media_ids.value.includes(id);
    const order = store.ordersWithPdf
      .filter((i) => i.pdfFiles.map((j) => j.id).includes(id))
      .flatMap((i) => i.id);
    if (isChecked) {
      store.form.removeMedia(id);
      store.form.removeOrder(order);
    } else {
      store.form.addOrder(order);
      store.form.addMedia(id);
    }
  };

  return (
    <Box mb="5">
      <Card sectioned>
        <h2 className="text-3xl font-semibold mb-8">
          {store.type === InvoiceTypeEnum.CreditNote
            ? t`Files to attach with credit note`
            : t`Files to attach with invoice`}
        </h2>

        {!!pdfFiles.brand?.length && (
          <ExpandableItem
            headerClassName="bg-gray-100 py-3"
            mainClassName="p-6"
            header={
              <Fragment>
                <h3 className="font-semibold text-2xl">{t`Related to brands`}</h3>
                <p className="ml-8 text-xl">{t`${pdfFiles.brand?.length} documents`}</p>
              </Fragment>
            }
          >
            {pdfFiles.brand?.map((i) => (
              <div
                key={i.id}
                className="flex items-center space-x-3 border-b border-polarisBorder last:border-0"
              >
                <Checkbox
                  isChecked={store.form.media_ids.value.includes(i.id)}
                  onChange={() => onCheck(i.id)}
                />
                <MediaRow file={i} showPreview showDownload />
              </div>
            ))}
          </ExpandableItem>
        )}

        {!!pdfFiles.project?.length && (
          <ExpandableItem
            headerClassName="bg-gray-100 py-3"
            mainClassName="p-6"
            header={
              <Fragment>
                <h3 className="font-semibold text-2xl">{t`Related to projects`}</h3>
                <p className="ml-8 text-xl">{t`${pdfFiles.project?.length} documents`}</p>
              </Fragment>
            }
            defaultExpanded
          >
            {pdfFiles.project?.map((i) => (
              <div
                key={i.id}
                className="flex items-center space-x-3 border-b border-polarisBorder last:border-0"
              >
                <Checkbox
                  isChecked={store.form.media_ids.value.includes(i.id)}
                  onChange={() => onCheck(i.id)}
                />
                <MediaRow file={i} showPreview showDownload />
              </div>
            ))}
          </ExpandableItem>
        )}
      </Card>
    </Box>
  );
});
